<template>
    <div>
        <div class="col-md-8 mx-auto" style="border: none!important;">
            <v-row class="mt-5">
                <v-col cols="12" md="6">
                    <v-text-field
                            v-model="title"
                            label="عنوان دسته"
                            required
                            dense
                            outlined
                            class="mt-1"
                            prepend-inner-icon="fa fa-pencil-alt"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field
                            v-model="slug"
                            label="نامک"
                            outlined
                            required
                            dense
                            prepend-inner-icon="fa fa-pencil-alt"
                            class="mt-1"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field
                            label="اولویت"
                            v-model="priority"
                            outlined
                            required
                            @keypress="onlyNumber($event)"
                            dense
                            prepend-inner-icon="fa fa-pencil-alt"
                            class="mt-1"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <image-uploader></image-uploader>
                </v-col>
            </v-row>
            <div class="col-md-12">
                <v-btn v-if="edit_id" @click="updateCategory" class="mt-5 btn-update">
                    <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                    ویرایش دسته
                </v-btn>
                <v-btn v-else @click="createCategory" class="mt-5 submit-btn ">
                    <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                    ثبت دسته
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import {Bus} from "../../../main";
import ImageUploader from "./imageUploader";
import AdminCategory from "./adminCategory";

export default {
    name: "createCategory",
    components: {AdminCategory, ImageUploader},
    props: {
        parent_id: {
            default: ''
        },
        edit_id: {
            default: ''
        },
        modal: {
            default: false
        }

    },
    data() {
        return {
            title: '',
            slug: '',
            priority: '',
            finalyIcon: '',
            showDatas: [],
        }
    },
    methods: {
        createCategory() {
            this.$api.post('admin/category', {
                "priority": this.priority || undefined,
                "parent_id": this.parent_id || undefined,
                "title": this.title || undefined,
                "slug": this.slug || undefined,
                "icon": this.finalyIcon || undefined
            }).then(() => {
                this.$modal.success('موفقیت‌ آمیز!', 'دسته موردنظر شما با موفقیت ساخته شد.');
                Bus.$emit('resetValues', true);
                this.modal();

            }).catch((error) => {
                this.$modal.error('خطا!', '', Object.keys(error.response.data.errors).map((key) => {
                    return error.response.data.errors[key][0]
                }).join('\n'));
            });
        },

        showCategory() {
            this.$api.get(`admin/category/${this.edit_id}`).then((response) => {
                this.priority = response.data.data.priority
                this.title = response.data.data.title
                this.slug = response.data.data.slug
            }).catch((error) => {
                this.$modal.error('خطا!', error.response.data.errors.image[0])
            });
        },

        updateCategory() {
            this.$api.put(`admin/category/${this.edit_id}`, {
                "priority": this.priority || undefined,
                "parent_id": this.parent_id || undefined,
                "title": this.title || undefined,
                "slug": this.slug || undefined,
                "icon": this.finalyIcon || undefined
            }).then(() => {
                this.$modal.success('موفقیت آمیز!', 'دسته موردنظر شما با موفقیت ویرایش شد');
                Bus.$emit('resetValues', true);
                this.modal();

            }).catch((error) => {
                this.$modal.error('خطا!', '', Object.keys(error.response.data.errors).map((key) => {
                    return error.response.data.errors[key][0]
                }).join('\n'));
            })
        },
    },
    mounted() {
        if (this.edit_id !== '') {
            this.showCategory();
        }
        Bus.$on('getImage', (value) => {
            this.finalyIcon = value[0];
        });
    }
}
</script>

<style scoped>

</style>